import { getBaseDomainFromUrl, getUrlInfo } from 'utils/helper/helper';

const { protocol, subdomain } = getUrlInfo();

export let BACKEND_URL = '';
switch (process.env.REACT_APP_ENV) {
  case 'production':
    BACKEND_URL = `${protocol}//${subdomain}${process.env.REACT_APP_BACKEND_DOMAIN}${process.env.REACT_APP_API_BASE_PATH}`;
    break;
  case 'staging':
    BACKEND_URL = `${protocol}//${subdomain}.${process.env.REACT_APP_BACKEND_DOMAIN}${process.env.REACT_APP_API_BASE_PATH}`;
    break;
  case 'development':
  default:
    BACKEND_URL = `${process.env.REACT_APP_PROTOCOL}//${subdomain}.${process.env.REACT_APP_BACKEND_DOMAIN}${process.env.REACT_APP_API_BASE_PATH}`;
    break;
}

export const TENANT = subdomain;

export const apiSubdomain = process.env.REACT_APP_ENV === 'production' ? `${TENANT}-api` : TENANT;

// the way to reliably get the domain, since it can have the port on local dev and staging prepended on staging
export const BASE_DOMAIN = getBaseDomainFromUrl(window.location.hostname);
